import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import {render} from 'react-dom';
import configureStore from './store';
import history from './services/history';
import App from './containers/App';

const store = configureStore();

render(<App history={history} store={store} />, document.getElementById('Application'));
